// extracted by mini-css-extract-plugin
module.exports = {"Logo":"SwaggerLogo_Logo__1ICnd"};